
import { defineComponent, PropType } from "vue";
import { getError } from "@/utils/helpers";
import TextField from "@/components/forms/TextField.vue";
// import FieldError from "@/components/forms/FieldError.vue";
import { RecordIdentifier } from "@/data/global";
import RegionService from "@/services/RegionService";
import { Region } from "@/data/region";
import GlobalStore from "@/utils/global-store";
import AuthService from "@/services/AuthService";

type Form = {
    name: string,
    email: string,
    phone: string,
    text: string,
};

type FormErrors = Record<string, string[]>;

declare interface ContactFormRegionData {
    loading: boolean,
    loadingSubmit: boolean,

    success: boolean,

    region: Region|null,

    form: Form,

    errors: FormErrors
}

export default defineComponent({
    name: 'ContactFormRegion',
    components: {
        // FieldError,
        TextField,
    },
    emits: [
        'sent',
        'close',
    ],
    props: {
        regionId: {
            type: [Number] as PropType<RecordIdentifier>,
            required: true,
        },
    },
    data(): ContactFormRegionData {
        return {
            loading: false,
            loadingSubmit: false,
            success: false,
            region: null,
            form: {
                name: '',
                email: '',
                phone: '',
                text: '',
            },
            errors: {},
        };
    },
    computed: {
        hasErrors() {
            return Object.keys(this.errors).length > 0;
        },
    },
    methods: {
        loadRegionInfo() {
            this.loading = true;
            RegionService.getRegionManager(this.regionId).then(response => {
                this.region = (response?.data?.data as Region) || null;
            }).catch(error => {
                //console.warn(error);
                //console.warn(getError(error));
                this.errors = getError(error);
            }).finally(() => this.loading = false);
        },
        prefillForm() {
            AuthService.getAuthUser().then((resp) => {
                if( !this.form.name ) {
                    this.form.name = resp.data?.data?.full_name || '';
                }
                if( !this.form.email ) {
                    this.form.email = resp.data?.data?.email || '';
                }
                if( !this.form.phone ) {
                    this.form.phone = resp.data?.data?.phone_mobile || '';
                }
            });
        },
        submitForm() {
            if( this.loading ) {
                return;
            }

            this.errors = {};
            this.loadingSubmit = true;
            RegionService.submitContactForm({ ...this.form, regionId: this.regionId }).then((resp) => {
                this.success = true;

                this.$emit('sent');

                this.errors = {};

            }).catch(error => {
                //console.warn(error);
                //console.warn(getError(error));
                this.errors = getError(error);
            }).finally(() => this.loadingSubmit = false);
        }
    },
    watch: {

    },
    mounted() {
        this.loadRegionInfo();

        if( GlobalStore.data.loggedIn ) {
            this.prefillForm();
        }
    },
});
